<template>
  <v-card v-if="summary" class="ma-2" :to="{ name: feature.tasks.routerName }">
    <v-card-text class="indigo lighten-5">
      <div class="d-flex">
        <div class="mt-4 mr-4">
          <v-icon large color="info">{{ icon.task }}</v-icon>
          <div class="ml-1 caption">Tasks</div>
        </div>
        <v-container>
          <v-row>
            <v-col>
              <TaskDashboardWidgetItem
                color="red"
                :iconName="icon.priorityHigh"
                caption="High"
                :value="summary.QuantityHighPriority"
              />
            </v-col>
            <v-col>
              <TaskDashboardWidgetItem
                color="orange"
                :iconName="icon.priorityHigh"
                caption="Medium"
                :value="summary.QuantityMediumPriority"
              />
            </v-col>
            <v-col>
              <TaskDashboardWidgetItem
                color="green"
                :iconName="icon.priorityLow"
                caption="Low"
                :value="summary.QuantityLowPriority"
              />
            </v-col>
          </v-row>
        </v-container>
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
import { ref } from 'vue'
import { feature, icon } from '@/use/Constants'
import { host } from '@/services/HostAPI'
import TaskDashboardWidgetItem from '@/components/ScheduledTask/TaskDashboardWidgetItem.vue'
export default {
  name: 'TaskDashboardWidget',
  components: { TaskDashboardWidgetItem },
  setup() {
    const summary = ref()

    const loadData = async () => {
      const rq = {
        TaskDate: new Date().toISOString().substr(0, 10)
      }
      const rs = await host.scheduledTask.getSummary(rq)
      summary.value = rs.Info
    }

    loadData()

    return { summary, feature, icon }
  }
}
</script>
